import UserInfoTop from './userInfoTop'
import UserInfoTabs from './userInfoTabs'
import { getCustomerSource } from '@/services/customerServices'
import { getCustomerInfo } from '@/services/customerManage'
import { getParentId } from '@/utils/common'
import { useParams } from 'react-router-dom'
import { useCallback, useEffect, useState } from 'react'
import dayjs from 'dayjs'
import { CustomerProvider } from '@/hooks/useCustomerInfo'
import React from 'react'
import { isArray } from 'lodash-es'

const UserInfo = (props: { refresh: boolean }) => {
  const { refresh } = props
  const { id } = useParams()
  const [loading, setLoading] = useState(true)
  const [customerInfo, setCustomerInfo] = useState<any>({})
  const [customerSourceList, setCustomerSourceList] = useState<any[]>([])

  // 获取客户详情
  const getCrmInfo = useCallback(
    async (list: any) => {
      const customerInfo: any = await getCustomerInfo({ id })

      // 根据 channelId 获取客户来源路径
      let idPath = []
      if (list?.length > 0 && customerInfo?.channelId) {
        idPath = getParentId(list, customerInfo?.channelId)?.reverse()
      }
      // 处理联系人信息
      let contactPersonObj:any = {};
      if(isArray(customerInfo?.contactPersonList)&&customerInfo?.contactPersonList?.length>0) {
        const {name:contactName,phone:contactPhone,relation:contactRelation,id:contactId,relationName:contactRelationName} = customerInfo?.contactPersonList[0];
        contactPersonObj = {
          contactName:contactName || "",
          contactPhone:contactPhone || "",
          contactRelation:contactRelation || "",
          contactRelationName:contactRelationName || "",
          contactId:contactId || "",
        }
      }

      setCustomerInfo({
        ...customerInfo,
        ...contactPersonObj,
        channelId: idPath,
        birthday: customerInfo?.birthday ? dayjs(customerInfo?.birthday) : undefined,
      })
      setLoading(false)
    },
    [id]
  )

  // 获取客户来源
  const getSource = useCallback(async () => {
    setLoading(true)
    const res: any = await getCustomerSource({ enabled: true })
    setCustomerSourceList(res)
    getCrmInfo(res)
  }, [getCrmInfo])

  useEffect(() => {
    getSource()
  }, [getSource, refresh])

  return (
    <CustomerProvider value={{ customerInfo, loading, customerSourceList }}>
      <div style={{ marginRight: 10, width: '65vw' }}>
        <UserInfoTop />
        <UserInfoTabs />
      </div>
    </CustomerProvider>
  )
}

export default React.memo(UserInfo)
